module.exports = __webpack_public_path__ + "img/9788925564760.2a0c655b.jpg";